import { handledGetFetch } from '../../submodules/shared/utils/api-base';

import { PATHS } from './paths';
import { buildUrl } from './url';

export const getAccountDetails = () => handledGetFetch(buildUrl(PATHS.accountDetails));

export const getOVPNCert = (labId, os) => handledGetFetch(buildUrl(PATHS.ovpnCert(labId), { os }));
